import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css';
import VueLuckyCanvas from '@lucky-canvas/vue'
import { Table, TableColumn } from 'element-ui';


Vue.config.productionTip = false
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(VueLuckyCanvas)

new Vue({
    render: h => h(App),
}).$mount('#app')